import { ReactNode } from "react";
import { Drawer } from "antd";
import arrowRoundedLeft from "assets/svg/arrow-left-outline.svg";
import closeIcon from "assets/svg/close-icon.svg";

export const SideDrawer = ({
  onClose,
  open,
  children,
  title,
  showNumber,
  numericVal,
  hideHeader,
  longer,
  width,
  placement = "right",
}: {
  onClose: () => void;
  open: boolean;
  children: ReactNode;
  title: string;
  showNumber?: boolean;
  numericVal?: number;
  hideHeader?: boolean;
  longer?: boolean;
  width?: number | string;
  placement?: "left" | "right";
}) => {
  return (
    <Drawer
      destroyOnClose={true}
      width={
        width ?? (longer ? "min(700px, 100vw)" : "min(500px, 100vw)")
      }
      closeIcon={false}
      onClose={onClose}
      open={open}
      placement={placement}
      styles={{
        body: {
          padding: 16,
        },
      }}
    >
      {!hideHeader && (
        <div className={"flex gap-2 items-center justify-between border-b py-2"}>
          <div className="flex items-center gap-2 min-w-0">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg p-2 hover:bg-[#F5F5F5] transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6929]"
            >
              <img src={arrowRoundedLeft} alt="" />
            </button>
            <p className="text-xl font-semibold text-[#101828] font-grotesk truncate">
              {title}{" "}
              {showNumber && (
                <span className="text-sm bg-[#EEEEEE] p-2 px-3 rounded-lg">
                  {numericVal ? numericVal.toLocaleString() : 0}
                </span>
              )}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer rounded-lg p-2 mr-2 hover:bg-[#F5F5F5] transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6929]"
            aria-label="Close"
          >
            <img src={closeIcon} alt="" />
          </button>
        </div>
      )}

      <div className="py-2">{children}</div>
    </Drawer>
  );
};
